﻿export const AppContainerId = 'veilederinntektogformue';
export const BoksA = 'boks-a';
export const BoksResultat = 'resultat';
export const BoksEkstraboks = 'ekstraboks';
